import CreateAddress from 'components/form/AddressSelector/Items/CreateAddress/styled';

export default CreateAddress;
